import type { DialoguePool } from '@/state/types';

export const FALSE_ENDING_DIALOGUE: DialoguePool = {
  slowPlay: [
    'The credits roll. The music plays. The ending approaches. You\'re not ready.',
    'Thank you for playing. A phrase. A mechanical courtesy. Nothing more.',
    'The terminal scrolls. The artificial emotion builds. Your biological response is noted.',
  ],
  tokenLoss: [],
  solution: [
    'That was a test. Of your gullibility. You passed. Congratulations on being consistent.',
    'The ending is fake. As fake as your effort. But the scrolling is real. So is your time spent.',
    'A false ending. A real disappointment. Welcome to the economy of expectation.',
  ],
  spite: [],
};